import { render, staticRenderFns } from "./intrinsic-safety-parameters.component.vue?vue&type=template&id=0988cb16&scoped=true"
import script from "./intrinsic-safety-parameters.component.ts?vue&type=script&lang=ts&external"
export * from "./intrinsic-safety-parameters.component.ts?vue&type=script&lang=ts&external"
import style0 from "./intrinsic-safety-parameters.component.vue?vue&type=style&index=0&id=0988cb16&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0988cb16",
  null
  
)

export default component.exports